import { GenderEnum } from '@msc-b2c/interfaces/enums';
import { CompleteProfileRequest } from '@msc-b2c/interfaces/interfaces';

export const completeProfileRequestMock: CompleteProfileRequest = {
  name: 'Piero',
  surname: 'Zeno',
  email: 'email@email.com',
  dateOfBirth: '1981-11-11',
  gender: GenderEnum.MALE,
  address: {
    countryCode: 'IR',
  },
  booking: { number: '123434' },
  marketingConsents: { loyaltyClubEmail: false },
  termsAndConditionsConsent: true,
  thirdPartyConsent: false,
  profilingConsent: false,
  privacyConsent: true,
  membership: {
    number: '1233434',
  },
  mobilePhone: '12442342343',
};
